<ng-container *ngIf="page">

  <section class="hero">
    <div class="container">
      <div class="row align-items-center gy-4">
        <div class="col-12 col-lg-6 hero__content">
          <h1 class="hero__title display-2 mb-3">{{ page.heroTitle }}</h1>
          <p class="hero__subtitle mb-4">{{ page.heroSubtitle }}</p>
          <div class="d-flex flex-column flex-sm-row gap-3">
            <a [routerLink]="[]" fragment="our-story" class="btn ui-btn ui-btn--primary fw-bold">{{ page.heroPrimaryCtaText }}</a>
            <a [routerLink]="[]" fragment="how-we-show-up" class="btn ui-btn ui-btn--outline-light fw-bold">{{ page.heroSecondaryCtaText }}</a>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="hero__image-wrapper position-relative">
            <span class="hero__badge">{{ page.heroBadgeText }}</span>
            <img [src]="page.heroImageSrc" alt="" class="hero__image w-100">
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="story py-5" id="our-story">
    <div class="container position-relative">
      <app-background-icon
        src="/assets/images/icons/carry_crate.svg"
        [top]="8"
        [left]="6"
        [width]="150"
        [opacity]="0.5"
      />
      <app-background-icon
        src="/assets/images/icons/paw.svg"
        [top]="10"
        [left]="93"
        [width]="170"
        [opacity]="0.5"
      />
      <app-background-icon
        src="/assets/images/icons/kennel.svg"
        [top]="92"
        [left]="6"
        [width]="170"
        [opacity]="0.5"
      />
      <app-background-icon
        src="/assets/images/icons/medicine.svg"
        [top]="92"
        [left]="94"
        [width]="140"
        [opacity]="0.5"
      />

      <h2 class="story__title display-4 text-center mb-2">{{ page.storyTitle }}</h2>
      <p class="story__subtitle text-center mb-5">{{ page.storySubtitle }}</p>

      <div class="story__timeline d-flex flex-column gap-4">
        <app-story-timeline-item *ngFor="let item of page.storyItems" [item]="item"></app-story-timeline-item>
      </div>
    </div>
  </section>

  <section class="show-up py-5" id="how-we-show-up">
    <div class="container position-relative text-center pb-5">
      <app-background-icon
        src="/assets/images/icons/bone.svg"
        [top]="12"
        [left]="6"
        [width]="150"
        [opacity]="0.1"
      />
      <app-background-icon
        src="/assets/images/icons/cat.svg"
        [top]="14"
        [left]="94"
        [width]="150"
        [opacity]="0.1"
      />
      <app-background-icon
        src="/assets/images/icons/carry_crate.svg"
        [top]="95"
        [left]="6"
        [width]="130"
        [opacity]="0.1"
      />
      <app-background-icon
        src="/assets/images/icons/medicine.svg"
        [top]="95"
        [left]="94"
        [width]="120"
        [opacity]="0.1"
      />

      <h2 class="show-up__title display-4 mb-2">{{ page.showUpTitle }}</h2>
      <p class="show-up__subtitle mx-auto mb-5">{{ page.showUpSubtitle }}</p>

      <div class="row g-4">
        <div class="col-12 col-md-4" *ngFor="let card of page.showUpCards">
          <app-icon-card [iconSrc]="card.iconSrc" [title]="card.title" [description]="card.description" variant="white"></app-icon-card>
        </div>
      </div>
    </div>
  </section>

  <app-trust-section [title]="page.trustTitle" [subtitle]="page.trustSubtitle"></app-trust-section>

</ng-container>
